import React, { useEffect} from 'react';
import { connect, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { getList, openDropDown } from '../../redux/actions/actions';
import './kus.scss';

const Kus = (props: any) => {
    const { dropDownShow } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getList())
    }, [dispatch]);

    const dropDown = () => {
        dispatch(openDropDown(dropDownShow.dropDownShow ? false : 'counties'))
    }
    //const icon = dropDownShow.dropDownShow ? faChevronUp : faChevronDown
    let icon = faChevronDown;
    if (dropDownShow.type === 'counties' && dropDownShow.dropDownShow) {
        icon = faChevronUp;
    }
    return (
        <div className="filter-dropdown" onClick={dropDown}>
            <div>Kus</div>
            <FontAwesomeIcon icon={icon as any} />
        </div>
    );
}

const mapStateToProps = (state: any) => {
    const { counties, dropDownShow } = state;
    return { counties, dropDownShow };
};

export default connect(mapStateToProps,{getList})(Kus);
